<template>
  <v-card flat class="transparent-bg">
    <div class="mb-4">
      <v-item-group v-model="localTheme" mandatory class="custom-flex-container">
        <v-item 
          v-for="theme in specialThemes" 
          :key="theme.id" 
          v-slot="{ active, toggle }" 
          :value="theme.id"
        >
          <v-card
            :class="['theme-card transition-swing rounded-xl', active ? 'active-card elevation-6' : 'elevation-2']"
            @click="toggle"
            ripple
          >
            <!-- آیکون تیک برای تم انتخاب شده -->
            <div class="card-header d-flex justify-end pa-2 position-absolute w-100" style="z-index: 2;">
              <v-icon v-if="active" color="white" class="active-icon" size="24">mdi-check-circle</v-icon>
              <v-icon v-else color="grey lighten-1" size="24">mdi-circle-outline</v-icon>
            </div>

            <!-- تصویر پیش‌نمایش تم -->
            <div class="img-container pa-2">
              <v-img
                :src="theme.src"
                contain
                height="120"
                class="rounded-lg"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>

            <!-- عنوان تم -->
            <v-card-actions class="justify-center py-2 bg-blur">
              <span :class="['font-weight-medium text-body-2', active ? 'primary--text font-weight-bold' : 'grey--text text--darken-2']">
                {{ theme.title }}
              </span>
            </v-card-actions>
          </v-card>
        </v-item>
      </v-item-group>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ThemeSelector2",
  
  props: {
    value: {
      type: Object,
      default: () => ({ theme: "theme_1" })
    }  },

  data() {
    return {
      specialThemes: [
        { 
          id: "theme_1", 
          title: "مدل کلاسیک 1", 
          src: "/media/menu/theme_1.webp"
        },
        { 
          id: "theme_2", 
          title: "مدل کلاسیک 2", 
          src: "/media/menu/theme_2.webp" 
        }, { 
          id: "theme_3", 
          title: "مدل کلاسیک 3", 
          src: "/media/menu/theme_3.webp"
        }, { 
          id: "theme_4", 
          title: "مدل کلاسیک 4", 
          src: "/media/menu/theme_4.webp"
        },
      ]
    };
  },

  computed: {
        localTheme: {
      get() {
        return this.value?.theme;
      },
      set(val) {
        this.$emit("input", { ...this.value, theme: val });
      }
    },
  }
};
</script>

<style scoped>
.transparent-bg {
  background: transparent !important;
}

.custom-flex-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px; /* فاصله مناسب بین کارت‌ها وقتی کنار هم قرار می‌گیرند */
  width: 100%;
}

.theme-card {
  border: 2px solid transparent;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px);
  width: 110px;
height: auto;
  flex: 0 0 auto; 

}

.theme-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 20px -10px rgba(25, 118, 210, 0.3) !important;
}

.active-card {
  border-color: #1976d2 !important;
  background: rgba(25, 118, 210, 0.05) !important;
}

.img-container {
  background: #f8f9fa;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.bg-blur {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(5px);
  border-top: 1px solid rgba(0,0,0,0.05);
}

.active-icon {
  background-color: #1976d2;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  z-index: 2;
}
</style>
